import React, { Component } from 'react'
import { Modal } from 'reactstrap'
import questionTypes from '../Survey/data/avatarQuestionTypes'
import AffiliateSearch from '../../../../components/AffiliateSearch/AffiliateSearch'
import AvatarTemplateQuestionSearch from '../../../../components/AvatarTemplateQuestionSearch/AvatarTemplateQuestionSearch'

class AddQuestionModal extends Component {
    constructor(props) {
        super(props)
        this.form = React.createRef()
    }

    state = {
        question: false,
    }

    saveQuestion = (e) => {
        e.preventDefault()

        let question = e.target.question.value
        let questionType = e.target.questionType.value

        if (question.length === 0) {
            // Get the default question type name
            let questionTypeObj = questionTypes.find((findQuestionType) => {
                return findQuestionType.type === questionType
            })
            question = questionTypeObj.name
        }

        this.props.handleAddQuestion(question, questionType)
    }

    render() {
        return (
            <Modal isOpen={this.props.open} toggle={this.props.closeModal} className="modal-md">
                
                <div className="modal-header">
                    <h5 className="modal-title">Add a new question</h5>
                    <button type="button" className="close" onClick={this.props.closeModal}>
                        <span aria-hidden="true">x</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="alert alert-secondary">
                        <label htmlFor="question_type">Build from Template? :</label>
                        <select className="form-control" name="isTemplate" onChange={(e) => {
                            this.props.setIsTemplate(e.target.value === 'true')
                            this.setState({ question: false }) // Reset the question when toggling template mode
                        }}>
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                        </select>
                    </div>
                    {!this.props.isTemplate ? (
                    <form ref={this.form} onSubmit={this.saveQuestion} className="mt-3">
                        <div className="form-group">
                            <label htmlFor="question">Question:</label>
                            <textarea maxLength={600} className="form-control" type="text" name="question" placeholder="Question text..."></textarea>
                        </div>
                        <div className="form-group">
                            <label htmlFor="question_type">Question Type:</label>
                            <select className="form-control" name="questionType">
                                {questionTypes.map((questionType) => {
                                    return (
                                        <option key={questionType.type} value={questionType.type}>
                                            {questionType.name}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="text-center">
                            <button className="btn btn-primary">Add Question</button>
                        </div>
                    </form>
                    ) : (
                        <div className="form-group mt-2">
                            <label htmlFor="affiliate">Template Question:</label>
                            <AvatarTemplateQuestionSearch question={this.state.question} setQuestion={(question) => {
                                this.setState({ question })
                            }} />
                            <div className="text-center mt-2">
                                <button className="btn btn-primary" onClick={() => {
                                    this.props.setTemplateId(this.state.question.id)
                                    this.props.handleAddQuestion(this.state.question.name, this.state.question.type, this.state.question.id)
                                    this.props.closeModal()
                                }} disabled={!this.state.question}>
                                    Add Question
                                </button>
                                </div>
                        </div>
                    )}
                </div>
            </Modal>
        )
    }
}

export default AddQuestionModal
